export default {
  getWindowImage(state, _, _store, allGetters) {
    const model = allGetters?.['models/getModel'];
    const subModel = allGetters?.['models/getSubModel'];
    const cameraPhoto = allGetters?.['models/getCameraPhoto'];

    if (cameraPhoto) {
      return cameraPhoto;
    }

    const valueState = state.windowActive?.state;
    if (valueState && subModel?.window_state) {
      return valueState[subModel.window_state];
    }

    if (valueState && model?.window_state) {
      return valueState[model.window_state];
    }

    if (valueState?.openedX) {
      return valueState.openedX;
    }

    return '/img/window.png';
  },

  getInteriorActive(state, _, _store, allGetters) {
    const model = allGetters?.['models/getCurrentModel'];
    const isModelRoofSystem = allGetters?.['models/getIsModelRoofSystem'];
    const cameraPhoto = allGetters?.['models/getCameraPhoto'];

    if (cameraPhoto) {
      return cameraPhoto;
    }

    if (isModelRoofSystem) {
      return model?.image_system || '';
    }

    return state.interiorActive?.image || '';
  },
};
